import { render, staticRenderFns } from "./editIntegralRuleFee.vue?vue&type=template&id=7db34298"
import script from "./editIntegralRuleFee.vue?vue&type=script&lang=js"
export * from "./editIntegralRuleFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports